// src/etapas/EtapaContrato.js
import React, { useState, useRef, useEffect } from 'react';

function EtapaContrato({ onNext, onBack, setDados, dados }) {
  const [aceito, setAceito] = useState(dados.etapa6?.termoAceito || false);
  const contratoRef = useRef();
  const [mostrarCompleto, setMostrarCompleto] = useState(false);
  const [conteudoContrato, setConteudoContrato] = useState('');

  useEffect(() => {
    fetch('/contrato.txt')
      .then((res) => res.text())
      .then((texto) => setConteudoContrato(texto))
      .catch((err) => {
        console.error('Erro ao carregar contrato:', err);
        setConteudoContrato('Não foi possível carregar os termos do contrato.');
      });
  }, []);

  const handleImprimir = () => {
    const printContent = contratoRef.current.innerHTML;
    const win = window.open('', '', 'height=700,width=900');
    win.document.write('<html><head><title>Termo de Compromisso</title></head><body>');
    win.document.write(printContent);
    win.document.write('</body></html>');
    win.document.close();
    win.print();
  };

  const handleAvancar = () => {
    setDados((prev) => ({
      ...prev,
      etapa6: {
        termoAceito: true
      }
    }));

    console.log('Dados recebidos na etapa 6:', dados);

    onNext();
  };

  return (
    <div>
      <h4 className="fw-semibold text-center mb-4" style={{ fontSize: '1.5rem', color: '#444' }}>
        Termo de Compromisso / Contrato
      </h4>

      <div className="border p-3 bg-light" ref={contratoRef} style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <h5>Resumo do Termo</h5>
        <p style={{ whiteSpace: 'pre-line' }}>
          {mostrarCompleto ? conteudoContrato : `${conteudoContrato.slice(0, 500)}...`}
        </p>
        {conteudoContrato.length > 500 && (
          <button
            className="btn btn-link btn-sm"
            onClick={() => setMostrarCompleto((prev) => !prev)}
          >
            {mostrarCompleto ? 'Mostrar menos' : 'Ler mais'}
          </button>
        )}
      </div>

      <div className="form-check mt-3">
        <input
          type="checkbox"
          className="form-check-input"
          id="aceite"
          checked={aceito}
          onChange={(e) => setAceito(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="aceite">
          Confirmo que li e aceito os termos apresentados acima.
        </label>
      </div>

      <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-secondary" onClick={onBack}>Voltar</button>
        <div>
          <button className="btn btn-outline-dark me-2" onClick={handleImprimir}>
            <i className="fa fa-print me-1"></i> Imprimir
          </button>
          <button className="btn btn-primary" onClick={handleAvancar} disabled={!aceito}>
            Avançar
          </button>
        </div>
      </div>
    </div>
  );
}

export default EtapaContrato;
